import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32 0H0V32H32V0Z",
      class: "bg",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.6666 10.667H6.66665C5.93027 10.667 5.33331 11.2639 5.33331 12.0003V20.0003C5.33331 20.7367 5.93027 21.3337 6.66665 21.3337H14.6666C15.403 21.3337 16 20.7367 16 20.0003V12.0003C16 11.2639 15.403 10.667 14.6666 10.667Z",
      class: "primary",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M25.3334 10.667H20C19.2636 10.667 18.6667 11.2639 18.6667 12.0003V13.3337C18.6667 14.07 19.2636 14.667 20 14.667H25.3334C26.0697 14.667 26.6667 14.07 26.6667 13.3337V12.0003C26.6667 11.2639 26.0697 10.667 25.3334 10.667Z",
      class: "secondary",
      fill: "#959FEB"
    }, null, -1),
    _createElementVNode("path", {
      d: "M25.3334 17.333H20C19.2636 17.333 18.6667 17.93 18.6667 18.6663V19.9997C18.6667 20.7361 19.2636 21.333 20 21.333H25.3334C26.0697 21.333 26.6667 20.7361 26.6667 19.9997V18.6663C26.6667 17.93 26.0697 17.333 25.3334 17.333Z",
      class: "secondary",
      fill: "#959FEB"
    }, null, -1)
  ])))
}
export default { render: render }